// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3GWah","col":"CardReaderDesc_col__3tU0n","label":"CardReaderDesc_label__3QRWo"};